import { connect } from "react-redux";
import { State } from "store";
import { notification } from "store/notification";
import { profile } from "store/profile";
import { router } from "store/router";
import { title } from "store/title";

const mapStateToProps = (state: State) => ({
  currentUser: profile.selectors.User(state),
  unSeenNumber: notification.selectors.unSeenNumber(state)
});

const mapDispatchToProps = {
  setHeadBar: title.actions.setHeadBar,
  gotoNotifications: router.goto.notifications,
  setUnSeenNumber: notification.actions.setUnSeenNumber
};

export default connect(mapStateToProps, mapDispatchToProps);
